import { IEplassVulnerabilityData } from '../../../../redux/vulnerabilities/sliceVulnerabilities';

/**
 * Determines the vulnerability's type, as a value of the VulnerabilityStatus enum.
 * @param status - Vulnerability status string.
 */
export const getBaseVulnerabilityState = (status: string): VulnerabilityState => {
    if (/new/i.test(status)) {
        return VulnerabilityState.New;
    }

    if (/active/i.test(status)) {
        return VulnerabilityState.Active;
    }

    if (/closed/i.test(status)) {
        return VulnerabilityState.Closed;
    }

    if (/critical/i.test(status)) {
        return VulnerabilityState.Critical;
    }

    if (/high/i.test(status)) {
        return VulnerabilityState.High;
    }

    if (/medium/i.test(status)) {
        return VulnerabilityState.Medium;
    }

    if (/low/i.test(status)) {
        return VulnerabilityState.Low;
    }

    return VulnerabilityState.None;
};

/**
 * Creates the category structure for the tile view.
 * @param data - Vulnerability data to organise.
 */
export const buildVulnerabilityGroups = (data: IEplassVulnerabilityData[]) => {
    const tree: { [id: string]: IEplassVulnerabilityData[] } = {};

    data.forEach((x: IEplassVulnerabilityData): void => {
        if (!tree[x.ticketId]) {
            tree[x.ticketId] = [];
        }

        tree[x.ticketId].push(x);
    });

    return tree;
};

/**
 * Filters a list of user vulnerabilities depending on the active view type and/or filter text.
 * @param vulnerabilities - List of user vulnerabilities.
 * @param searchText - String value to filter the vulnerabilities by.
 * @param vPropNames - Property names for each Vulnerability.
 * @returns Filtered vulnerabilities.
 */
export const filterVulnerabilities = (
    vulnerabilities: IEplassVulnerabilityData[],
    searchText: string,
    vPropNames: string[],
): IEplassVulnerabilityData[] => {
    return vulnerabilities.filter(vulnerability => {
        const vPropValues: string[] = vPropNames.map(vProp => vulnerability[vProp].toString());

        return vPropValues.some(val => new RegExp(searchText, 'i').test(val));
    });
};

/**
 * Eplass vulnerability status and severity.
 */
export enum VulnerabilityState {
    New,
    Active,
    Closed,
    Critical,
    High,
    Medium,
    Low,
    None,
}
